//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import ProfileMixinDestinations from "~/components/profile/mixins/ProfileMixinDestinations"
import { BFormSelect, BFormSelectOption } from 'bootstrap-vue'

export default {

    name: 'PartialProfiles',

    mixins: [ProfileData, ProfileMixinDestinations],

    components: { BFormSelect, BFormSelectOption },

    props: {
        company: {
        },
        spinner: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            visible: true,
            isReady: false,
            showEntriesInit: 8,
            profilesShowed: 0,
            profileSelected: 'all',
        }
    },

    mounted() {
        this.profilesShowed = this.showEntriesInit - 1
    },

    methods: {

        masterProfileLink(profile) {

            if(profile.hasMultipleDestinations) {
                return $ziggy.route('profile.overview.destination.slug', {'id': profile.id, 'slug': profile.slug, 'destinationId':  profile.destinationProfileShow.id, 'destinationSlug': profile.destinationProfileShow.slug})
            }

            return $ziggy.route('profile.overview.id', {'id': profile.id, 'slug': profile.slug})
        },

        loadMoreProfiles() {
            this.profilesShowed += this.showEntriesInit
        },

        showProfileEntry(index, id) {

            if(this.profileSelected === 'all') {

                if(index <= this.profilesShowed) {
                    return true
                }

                return false
            }

            if(this.profileSelected === id) {
                return true
            }

            return false

        },
    },

    computed: {

/*        masterProfiles() {
            return this.$store.state.profile.masterProfiles
        },*/

        showSelectData() {
            return this.contactSelectDataLength > this.showEntriesInit
        },

        contactSelectData() {
            return this.$store.state.profile.contactSelectData
        },

        contactSelectDataLength() {
            return Object.keys(this.contactSelectData).length
        },

        showLoadMore() {

            if(this.profileSelected !== 'all') {
                return false
            }

            let length = this.masterProfiles.length

            if(length <= this.showEntriesInit) {
                return false
            }

            let showed = this.profilesShowed + 1

            if(showed >= length) {
                return false
            }

            return true
        },

        showSpinner() {

            if(this.spinner === false) {
                return false
            }

            if(this.isReady === false) {
                return true
            }

            return false
        },

    },

}

